import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import StatsBar from "@/pages/home/components/StatsBar";
import DramaSection from "@/pages/home/components/DramaSection";
import WatchGuide from "@/pages/home/components/WatchGuide";
import ScheduleSection from "@/pages/home/components/ScheduleSection";
import ClassicsSection from "@/pages/home/components/ClassicsSection";
import TipsSection from "@/pages/home/components/TipsSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Testimonials from "@/pages/home/components/Testimonials";
import CtaBand from "@/pages/home/components/CtaBand";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <StatsBar />
        <DramaSection />
        <WatchGuide />
        <ScheduleSection />
        <ClassicsSection />
        <TipsSection />
        <FaqSection />
        <Testimonials />
        <CtaBand />
      </main>
      <SiteFooter />
    </div>
  );
}